import { render, staticRenderFns } from "./TypeFileDOCXIcon.vue?vue&type=template&id=6d6e4934&"
import script from "./TypeFileDOCXIcon.vue?vue&type=script&lang=js&"
export * from "./TypeFileDOCXIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports